import { TimeSlot } from "~/shared.types";
import { tw } from "~/utils";
import { convertTo12HourFormat, formatProviderLabel } from "../utils";

type TimeSlotChipProps = {
  slot: TimeSlot;
  onSelect: (timeSlot: TimeSlot, providerId?: number) => void;
  isSelected?: boolean;
  providerLabel?: string;
  className?: string;
};

export const TimeSlotChip = ({
  slot,
  onSelect,
  isSelected = false,
  providerLabel,
  className,
}: TimeSlotChipProps) => {
  const { providerName: name, providerTitle: title } = slot;
  const label = convertTo12HourFormat(slot.startTime);
  const provider = providerLabel ?? formatProviderLabel(name, title);

  return (
    <button
      type="button"
      onClick={() => onSelect(slot, slot.providerId)}
      aria-label={provider ? `${label} with ${provider}` : label}
      className={tw(
        "border-violet hover:bg-violet/10 text-indigo w-full cursor-pointer rounded-sm border-2 px-3 py-2 text-base transition-all",
        isSelected &&
          "bg-violet hover:text-indigo hover:bg-violet/10 text-white shadow-md",
        className,
      )}
    >
      {label}
    </button>
  );
};
